import React, { useEffect } from 'react'
import { Typography, Grid, Paper, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Link } from '@reach/router'
import { DEFAULT_TIME_BRACKETS } from '../constants'

const useStyles = makeStyles((theme) => ({
    cell: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0.5),
        elevation: 0
    },
    webhooksEnabled: {
        fill: theme.palette.success.main
    },
    webhooksDisabled: {
        fill: theme.palette.grey[300]
    }
}))

const TempoConfigRow = ({ projectId, name, tempoData, screensEnabled, hasTempoWebhook }) => {
    const classes = useStyles()
    const [ timeBrackets, setTimeBrackets ] = React.useState([])

    useEffect(() => {
        getTempoDetails(tempoData)
    },[])

    function getTempoDetails(tempoData) {
        if (!tempoData || Object.keys(tempoData).length === 0) {
            setTimeBrackets([])
        }

        if (tempoData.isochroneBracketInterval && tempoData.isochroneBracketInterval.length > 0) {
            setTimeBrackets(tempoData.isochroneBracketInterval)
        }
    }

    function isDefaultConfig (timeBrackets) {
        const sortedBrackets = timeBrackets.sort((a,b) => b - a)
        return JSON.stringify(DEFAULT_TIME_BRACKETS) === JSON.stringify(sortedBrackets)
    }

    function getDescriptionFromTimeBrackets (timeBrackets) {
        if (!timeBrackets.length) return 'Default'
        if (isDefaultConfig(timeBrackets)) return 'Default'
        return `Number of isochrones: ${timeBrackets.length}`
    }

    return (
        <Paper className={classes.container} elevation={0}>
            <Grid container>
                <Grid className={classes.cell} item xs={3}>
                    <Typography variant="body1">{name}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={4}>
                    <Typography variant="body1">{getDescriptionFromTimeBrackets(timeBrackets)}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={2}>
                    { screensEnabled || hasTempoWebhook ?
                        <FiberManualRecordIcon className={classes.webhooksEnabled}/> :
                        <FiberManualRecordIcon className={classes.webhooksDisabled}/>
                    }
                </Grid>
                <Grid className={classes.cell} item xs={3}>
                    <Link to={`${projectId}`}>
                        <Button color="primary">Edit</Button>
                    </Link>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default TempoConfigRow
